import React from 'react';
// import sections
import BlankSection from '../components/sections/BlankSection'
import AboutWelcome from '../components/sections/AboutWelcome';
import AboutHistory from '../components/sections/AboutHistory';
// import Testimonial from '../components/sections/Testimonial';
import Cta from '../components/sections/Cta';

const Home = () => {

  return (
    <>
      <AboutWelcome />
      <AboutHistory />
      <Cta split />
      <BlankSection />
    </>
  );
}

export default Home;